import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { Temperature } from "../Temperature";
import { LadderAggregate } from "./LadderAggregate";

export class LimitOrder extends CubiqTS.OrderDataImpl {
  public ordTemp: Temperature;
  public tempStale: boolean = true;

  public readonly isMarketBar: boolean = false;
  public readonly isLadderRate: boolean = false;
  public readonly isLadderAggregate: boolean = false;

  public dealtTracking: number = NaN;
  public perc: number = NaN;
  public percSort: number = NaN;

  public valueDateSort: number;
  public sibling: string;
  public position: string;
  public executedPerc: number;

  public isAggregated: boolean = false;
  public aggregate: LadderAggregate;
  public aggregateIndex: number;

  public get aggregationTrackingRate(): number {
    return this.aggregate.aggregationTrackingRate ?? 0.0;
  }

  public get aggregationInvertTrackingRate(): number {
    return this.aggregate.aggregationInvertTrackingRate ?? 0.0;
  }

  public get aggregateId(): string | null {
    return this.aggregate?.aggregateId ?? null;
  }

  public get aggregateOrderId() {
    return this.isAggregated ? this.aggregate.aggregateOrderId : this.orderId;
  }

  constructor(source: CubiqTS.OrderDataImpl, public isBlotterOrder: boolean) {
    super();
    Object.assign(this, source);
    this.postProcessData();
  }

  public postProcessData(): void {
    if (this.siblingRelationship != null && this.siblingRelationship.orderId != null) {
      this.sibling = this.siblingRelationship.orderId;
    }
  }

  public calculateExecutedPercentage() {
    let filled = this.executedQty;

    if (this.leavesQty != null && this.orderQty != null) {
      this.orderQty.minus(this.leavesQty);
    }

    if (filled != null && this.orderQty != null && !this.orderQty.isZero()) {
      this.executedPerc = Number(filled.dividedBy(this.orderQty)) * 100;
    }
  }

  public getPosition(context: {
    isInverted: (limitOrder: LimitOrder) => boolean | null;
    getLimitOrder: (orderId: string) => LimitOrder;
  }): { ccy: string; amt: CubiqTS.BigNumber } {
    let ccy;
    let amt;
    let clientIntent = this.clientIntent;

    if (context?.isInverted(this)) {
      ccy = this.nonBaseCode;
      clientIntent =
        clientIntent == CubiqTS.OrderIntent.BUY
          ? CubiqTS.OrderIntent.SELL
          : CubiqTS.OrderIntent.BUY;
      if (this.baseCode != this.fixedCode) {
        amt = this.leavesQty;
      } else {
        amt = this.leavesSettleQty;
      }
    } else if (this.baseCode == this.fixedCode) {
      ccy = this.baseCode;
      amt = this.leavesQty;
    } else {
      ccy = this.baseCode;
      amt = this.leavesSettleQty;
      clientIntent =
        clientIntent == CubiqTS.OrderIntent.BUY
          ? CubiqTS.OrderIntent.SELL
          : CubiqTS.OrderIntent.BUY;
    }

    if (clientIntent && clientIntent == CubiqTS.OrderIntent.SELL) {
      amt = amt.negated();
    }

    // this.aggregationPositionQty = amt;

    return {
      ccy: ccy,
      amt: amt ?? CubiqTS.BigNumber("0"),
    };
  }
}
